import { useAuthStore, userProfileSelector } from 'modules/auth/core';

export const useUserProfileController = () => {
  const userProfile = useAuthStore(userProfileSelector);

  return {
    userProfile,
  };
};
